import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import adminList from '@/pages/admin/adminList' //管理员列表
import index from '@/pages/index' //首页
import login from '@/pages/login' //登录
import hanjie from '@/pages/chejian/hanjie.vue'
import fengren from '@/pages/chejian/fengren.vue'
import bianteng from '@/pages/chejian/bianteng.vue'
import baozhuang from '@/pages/chejian/baozhuang.vue'
import chengxing from '@/pages/chejian/chengxing.vue'
import zuzhuang from '@/pages/chejian/zuzhuang.vue'
import dadutou from '@/pages/chejian/dadutou.vue'
import tuzhuanglinxi from '@/pages/chejian/tuzhuanglinxi.vue'
import tuzhuangliangting from '@/pages/chejian/tuzhuangliangting.vue'
import hanjiebiao from '@/pages/form/hanjiebiao.vue'
import hanjiehetong from '@/pages/form/hanjiehetong.vue'
import fengrenbiao from '@/pages/form/fengrenbiao.vue'
import biantengbiao from '@/pages/form/biantengbiao.vue'
import fengrengongzi from '@/pages/form/fengrengongzi.vue'
import biantenggongzi from '@/pages/form/biantenggongzi.vue'
import biantengtoushi from '@/pages/form/biantengtoushi.vue'
import fengrengongziDetail from '@/pages/form/fengrengongziDetail.vue'
import fengrenhetong from '@/pages/form/fengrenhetong.vue'
import baozhuanghetong from '@/pages/form/baozhuanghetong.vue'
import chengxinghetong from '@/pages/form/chengxinghetong.vue'
import zuzhuanghetong from '@/pages/form/zuzhuanghetong.vue'
import tuzhuanglinxihetong from '@/pages/form/tuzhuanglinxihetong.vue'
import tuzhuangliangtinghetong from '@/pages/form/tuzhuangliangtinghetong.vue'
import dadutouhetong from '@/pages/form/dadutouhetong.vue'
import member from '@/pages/admin/member.vue'
import fengrenMb from '@/pages/admin/fengrenMb.vue'
import baozhuangMb from '@/pages/admin/baozhuangMb.vue'
import chengxingMb from '@/pages/admin/chengxingMb.vue'
import zuzhuangMb from '@/pages/admin/zuzhuangMb.vue'
import dadutouMb from '@/pages/admin/dadutouMb.vue'
import tuzhuanglinxiMb from '@/pages/admin/tuzhuanglinxiMb.vue'
import tuzhuangliangtingMb from '@/pages/admin/tuzhuangliangtingMb.vue'
import hanjieMb from '@/pages/admin/hanjieMb.vue'
import biantengMb from '@/pages/admin/biantengMb.vue'
import zhiweiMb from '@/pages/admin/zhiweiMb.vue'
import gzhuizongMb from '@/pages/admin/gzhuizongMb.vue'
// import gongxuMb from '@/pages/admin/gongxuMb.vue'
import frgz from '@/pages/gongzi/frgz.vue'
import cxgz from '@/pages/gongzi/cxgz.vue'
import bzgz from '@/pages/gongzi/bzgz.vue'
import zzgz from '@/pages/gongzi/zzgz.vue'
import hjgz from '@/pages/gongzi/hjgz.vue'
import hanjieyuegz from '@/pages/gongzi/hanjieyuegz.vue'
import tzgz from '@/pages/gongzi/tzgz.vue'
import tzlxgz from '@/pages/gongzi/tzlxgz.vue'
import tzltgz from '@/pages/gongzi/tzltgz.vue'
import tzgzMb from '@/pages/gongzi/tzgzMb.vue'
import tzddtgzMb from '@/pages/gongzi/tzddtgzMb.vue'
import tzddtgz from '@/pages/gongzi/tzddtgz.vue'
import gzhuizong from '@/pages/gongzi/gzhuizong.vue'
import frgzb from '@/pages/gongzibiao/frgzb.vue'
import cxgzb from '@/pages/gongzibiao/cxgzb.vue'
import bzgzb from '@/pages/gongzibiao/bzgzb.vue'
import zzgzb from '@/pages/gongzibiao/zzgzb.vue'
import hjgzb from '@/pages/gongzibiao/hjgzb.vue'
import tzgzb from '@/pages/gongzibiao/tzgzb.vue'
import tzlxgzb from '@/pages/gongzibiao/tzlxgzb.vue'
import tzltgzb from '@/pages/gongzibiao/tzltgzb.vue'
import tzddtgzb from '@/pages/gongzibiao/tzddtgzb.vue'
import gzhuizongb from '@/pages/gongzibiao/gzhuizongb.vue'
import hanjieyuegzb from '@/pages/gongzibiao/hanjieyuegzb.vue'
import fengrengzMb from '@/pages/gongzimb/fengrengzMb.vue'
import baozhuanggzMb from '@/pages/gongzimb/baozhuanggzMb.vue'
import chengxinggzMb from '@/pages/gongzimb/chengxinggzMb.vue'
import zuzhuanggzMb from '@/pages/gongzimb/zuzhuanggzMb.vue'
import hanjiegzMb from '@/pages/gongzimb/hanjiegzMb.vue'
import hanjieyueMb from '@/pages/gongzimb/hanjieyueMb.vue'
import huamingce from '@/pages/qita/huamingce.vue'
import jixiao from '@/pages/qita/jixiao.vue'
import linshiyonggong from '@/pages/qita/linshiyonggong.vue'
import heduibiao from '@/pages/qita/heduibiao.vue'
import yuefengren from '@/pages/yuegongzi/yuefengren.vue'
import yuebaozhuang from '@/pages/yuegongzi/yuebaozhuang.vue'
import yuechengxing from '@/pages/yuegongzi/yuechengxing.vue'
import yuezuzhuang from '@/pages/yuegongzi/yuezuzhuang.vue'
import yuehanjie from '@/pages/yuegongzi/yuehanjie.vue'
import yuetuzhuangddt from '@/pages/yuegongzi/yuetuzhuangddt.vue'
import yuetuzhuang from '@/pages/yuegongzi/yuetuzhuang.vue'
import yuerbfengren from '@/pages/yueribao/yuerbfengren.vue'
import yuerbbaozhuang from '@/pages/yueribao/yuerbbaozhuang.vue'
import yuerbchengxing from '@/pages/yueribao/yuerbchengxing.vue'
import yuerbzuzhuang from '@/pages/yueribao/yuerbzuzhuang.vue'
import yuerbhanjie from '@/pages/yueribao/yuerbhanjie.vue'
import yuerbliangting from '@/pages/yueribao/yuerbliangting.vue'
import yuerblinxi from '@/pages/yueribao/yuerblinxi.vue'
import zdyrbfengren from '@/pages/zidingyiribao/zdyrbfengren.vue'
import zdyrbbaozhuang from '@/pages/zidingyiribao/zdyrbbaozhuang.vue'
import zdyrbchengxing from '@/pages/zidingyiribao/zdyrbchengxing.vue'
import zdyrbzuzhuang from '@/pages/zidingyiribao/zdyrbzuzhuang.vue'
import zdyrbhanjie from '@/pages/zidingyiribao/zdyrbhanjie.vue'
import zdyrblinxi from '@/pages/zidingyiribao/zdyrblinxi.vue'
import zdyrbliangting from '@/pages/zidingyiribao/zdyrbliangting.vue'


import formIndex from '@/pages/form/index.vue'
import adminIndex from '@/pages/admin/index.vue'
import chejianIndex from '@/pages/chejian/index.vue'
import gongziIndex from '@/pages/gongzi/index.vue'
import gongzibiaoIndex from '@/pages/gongzibiao/index.vue'
import gongzimbIndex from '@/pages/gongzimb/index.vue'
import qitaIndex from '@/pages/qita/index.vue'
import yuegongziIndex from '@/pages/yuegongzi/index.vue'
import yueribaoIndex from '@/pages/yueribao/index.vue'
import zidingyiribaoIndex from '@/pages/zidingyiribao/index.vue'

const vueRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
		{
      path: '/',
      name: 'index',
      meta: {
        title: '首页'
      },
      component: index
    },
    {
      path: '/login',
      name: 'login',
			meta: {
        title: '登录'
      },
      component: login
    },
    {
      path: '/chejian',
      redirect: '/chejian/hanjiebiao',
      component: chejianIndex,
      children: [{
        path: '/fengren',
        name: 'fengren',
        meta: {
          title: '缝纫车间'
        },
        component: fengren
      },
      {
        path: '/baozhuang',
        name: 'baozhuang',
        meta: {
          title: '包装车间'
        },
        component: baozhuang
      },
      {
        path: '/chengxing',
        name: 'chengxing',
        meta: {
          title: '成型车间'
        },
        component: chengxing
      },
      {
        path: '/zuzhuang',
        name: 'zuzhuang',
        meta: {
          title: '组装车间'
        },
        component: zuzhuang
      },
      {
        path: '/hanjie',
        name: 'hanjie',
        meta: {
          title: '焊接车间'
        },
        component: hanjie
      },
      {
        path: '/tuzhuanglinxi',
        name: 'tuzhuanglinxi',
        meta: {
          title: '涂装淋洗车间'
        },
        component: tuzhuanglinxi
      },
      {
        path: '/tuzhuangliangting',
        name: 'tuzhuangliangting',
        meta: {
          title: '涂装凉亭车间'
        },
        component: tuzhuangliangting
      },
      {
        path: '/bianteng',
        name: 'bianteng',
        meta: {
          title: '编藤车间'
        },
        component: bianteng
      },
      {
        path: '/dadutou',
        name: 'dadutou',
        meta: {
          title: '打堵头车间'
        },
        component: dadutou
      }]
    },
    {
      path: '/gongzi',
      redirect: '/gongzi/frgz',
      component: gongziIndex,
      children: [{
        path: '/frgz',
        name: 'frgz',
        meta: {
          title: '缝纫工资'
        },
        component: frgz
      },{
        path: '/cxgz',
        name: 'cxgz',
        meta: {
          title: '成型工资'
        },
        component: cxgz
      },{
        path: '/bzgz',
        name: 'bzgz',
        meta: {
          title: '包装工资'
        },
        component: bzgz
      },{
        path: '/zzgz',
        name: 'zzgz',
        meta: {
          title: '组装工资'
        },
        component: zzgz
      },{
        path: '/hanjieyuegz',
        name: 'hanjieyuegz',
        meta: {
          title: '焊接工资'
        },
        component: hanjieyuegz
      },{
        path: '/tzgz',
        name: 'tzgz',
        meta: {
          title: '涂装人员工资'
        },
        component: tzgz
      },{
        path: '/tzgzMb',
        name: 'tzgzMb',
        meta: {
          title: '涂装日工资'
        },
        component: tzgzMb
      },{
      	path: 'tzddtgzMb',
        name: 'tzddtgzMb',
      	meta: {
      		title: '涂装打堵头模板',
          keepAlive: true
      	},
      	component: tzddtgzMb
      },{
      	path: 'tzddtgz',
        name: 'tzddtgz',
      	meta: {
      		title: '涂装打堵头工资',
          keepAlive: true
      	},
      	component: tzddtgz
      },{
        path: '/gzhuizong',
        name: 'gzhuizong',
        meta: {
          title: '工资汇总'
        },
        component: gzhuizong
      }]
    },
    {
      path: '/gongzibiao',
      redirect: '/gongzibiao/frgzb',
      component: gongzibiaoIndex,
      children: [{
        path: '/frgzb',
        name: 'frgzb',
        meta: {
          title: '缝纫工资表格'
        },
        component: frgzb
      },{
        path: '/cxgzb',
        name: 'cxgzb',
        meta: {
          title: '成型工资表格'
        },
        component: cxgzb
      },{
        path: '/bzgzb',
        name: 'bzgzb',
        meta: {
          title: '包装工资表格'
        },
        component: bzgzb
      },{
        path: '/zzgzb',
        name: 'zzgzb',
        meta: {
          title: '组装工资表格'
        },
        component: zzgzb
      },{
        path: '/hanjieyuegzb',
        name: 'hanjieyuegzb',
        meta: {
          title: '焊接工资表格'
        },
        component: hanjieyuegzb
      },{
        path: '/tzgzb',
        name: 'tzgzb',
        meta: {
          title: '涂装工资表格'
        },
        component: tzgzb
      },{
        path: '/tzddtgzb',
        name: 'tzddtgzb',
        meta: {
          title: '涂装打堵头工资表格'
        },
        component: tzddtgzb
      },{
        path: '/gzhuizongb',
        name: 'gzhuizongb',
        meta: {
          title: '工资汇总表格'
        },
        component: gzhuizongb
      }]
    },
		{
		  path: '/adminList',
		  name: 'adminList',
			meta: {
		    title: '账号管理'
		  },
		  component: adminList
		},
		{
		  path: '/member',
		  name: 'member',
			meta: {
		    title: '人员管理'
		  },
		  component: member
		},
		{
		  path: '/fengrengongziDetail',
		  name: 'fengrengongziDetail',
			meta: {
		    title: '缝纫工资详情'
		  },
		  component: fengrengongziDetail
		},
    {
      path: '/form',
      redirect: '/form/hanjiebiao',
      component: formIndex,
      children: [{
      	path: 'hanjiebiao',
        name: 'hanjiebiao',
      	meta: {
      		title: '焊接表格',
          keepAlive: true
      	},
      	component: hanjiebiao
      },{
      	path: 'hanjiehetong',
        name: 'hanjiehetong',
      	meta: {
      		title: '焊接合同表格',
          keepAlive: true
      	},
      	component: hanjiehetong
      },{
      	path: 'fengrenbiao',
        name: 'fengrenbiao',
      	meta: {
      		title: '缝纫表格',
          keepAlive: true
      	},
      	component: fengrenbiao
      },{
      	path: 'fengrengongzi',
        name: 'fengrengongzi',
      	meta: {
      		title: '缝纫工资表格',
          keepAlive: true
      	},
      	component: fengrengongzi
      },{
      	path: 'fengrenhetong',
        name: 'fengrenhetong',
      	meta: {
      		title: '缝纫合同表格',
          keepAlive: true
      	},
      	component: fengrenhetong
      },{
      	path: 'biantengbiao',
        name: 'biantengbiao',
      	meta: {
      		title: '编藤表格',
          keepAlive: true
      	},
      	component: biantengbiao
      },{
      	path: 'biantenggongzi',
        name: 'biantenggongzi',
      	meta: {
      		title: '编藤工资表格',
          keepAlive: true
      	},
      	component: biantenggongzi
      },{
      	path: 'biantengtoushi',
        name: 'biantengtoushi',
      	meta: {
      		title: '编藤透视表格',
          keepAlive: true
      	},
      	component: biantengtoushi
      },{
      	path: 'baozhuanghetong',
        name: 'baozhuanghetong',
      	meta: {
      		title: '包装合同表格',
          keepAlive: true
      	},
      	component: baozhuanghetong
      },{
      	path: 'chengxinghetong',
        name: 'chengxinghetong',
      	meta: {
      		title: '成型合同表格',
          keepAlive: true
      	},
      	component: chengxinghetong
      },{
      	path: 'zuzhuanghetong',
        name: 'zuzhuanghetong',
      	meta: {
      		title: '组装合同表格',
          keepAlive: true
      	},
      	component: zuzhuanghetong
      },
      {
        path: '/tuzhuanglinxihetong',
        name: 'tuzhuanglinxihetong',
        meta: {
          title: '涂装淋洗合同表格',
          keepAlive: true
        },
        component: tuzhuanglinxihetong
      },
      {
        path: '/tuzhuangliangtinghetong',
        name: 'tuzhuangliangtinghetong',
        meta: {
          title: '涂装凉亭合同表格',
          keepAlive: true
        },
        component: tuzhuangliangtinghetong
      },
      {
        path: '/dadutouhetong',
        name: 'dadutouhetong',
        meta: {
          title: '打堵头合同表格',
          keepAlive: true
        },
        component: dadutouhetong
      }]
    },
    {
      path: '/admin',
      redirect: '/admin/hanjieMb',
      component: adminIndex,
      children: [{
      	path: 'hanjieMb',
        name: 'hanjieMb',
      	meta: {
      		title: '焊接模板',
          keepAlive: true
      	},
      	component: hanjieMb
      },{
      	path: 'fengrenMb',
        name: 'fengrenMb',
      	meta: {
      		title: '缝纫模板',
          keepAlive: true
      	},
      	component: fengrenMb
      },{
      	path: 'baozhuangMb',
        name: 'baozhuangMb',
      	meta: {
      		title: '包装模板',
          keepAlive: true
      	},
      	component: baozhuangMb
      },{
      	path: 'chengxingMb',
        name: 'chengxingMb',
      	meta: {
      		title: '成型模板',
          keepAlive: true
      	},
      	component: chengxingMb
      },{
      	path: 'zuzhuangMb',
        name: 'zuzhuangMb',
      	meta: {
      		title: '组装模板',
          keepAlive: true
      	},
      	component: zuzhuangMb
      },{
      	path: 'tuzhuanglinxiMb',
        name: 'tuzhuanglinxiMb',
      	meta: {
      		title: '涂装淋洗模板',
          keepAlive: true
      	},
      	component: tuzhuanglinxiMb
      },{
      	path: 'tuzhuangliangtingMb',
        name: 'tuzhuangliangtingMb',
      	meta: {
      		title: '涂装凉亭模板',
          keepAlive: true
      	},
      	component: tuzhuangliangtingMb
      },{
      	path: 'biantengMb',
        name: 'biantengMb',
      	meta: {
      		title: '编藤模板',
          keepAlive: true
      	},
      	component: biantengMb
      },{
      	path: 'gzhuizongMb',
        name: 'gzhuizongMb',
      	meta: {
      		title: '工资汇总模板',
          keepAlive: true
      	},
      	component: gzhuizongMb
      },{
      	path: 'zhiweiMb',
        name: 'zhiweiMb',
      	meta: {
      		title: '职位模板',
          keepAlive: true
      	},
      	component: zhiweiMb
      },{
      	path: 'dadutouMb',
        name: 'dadutouMb',
      	meta: {
      		title: '打堵头模板',
          keepAlive: true
      	},
      	component: dadutouMb
      }]
    },
    {
      path: '/gongzimb',
      redirect: '/gongzimb/fengrengzMb',
      component: gongzimbIndex,
      children: [{
      	path: 'fengrengzMb',
        name: 'fengrengzMb',
      	meta: {
      		title: '缝纫工资模板',
          keepAlive: true
      	},
      	component: fengrengzMb
      },{
      	path: 'baozhuanggzMb',
        name: 'baozhuanggzMb',
      	meta: {
      		title: '缝纫工资模板',
          keepAlive: true
      	},
      	component: baozhuanggzMb
      },{
      	path: 'chengxinggzMb',
        name: 'chengxinggzMb',
      	meta: {
      		title: '成型工资模板',
          keepAlive: true
      	},
      	component: chengxinggzMb
      },{
      	path: 'zuzhuanggzMb',
        name: 'zuzhuanggzMb',
      	meta: {
      		title: '组装工资模板',
          keepAlive: true
      	},
      	component: zuzhuanggzMb
      },{
      	path: 'hanjieyueMb',
        name: 'hanjieyueMb',
      	meta: {
      		title: '焊接工资模板',
          keepAlive: true
      	},
      	component: hanjieyueMb
      }]
    },
    {
      path: '/qita',
      redirect: '/qita/huamingce',
      component: qitaIndex,
      children: [{
      	path: 'huamingce',
        name: 'huamingce',
      	meta: {
      		title: '花名册',
          keepAlive: true
      	},
      	component: huamingce
      },{
      	path: 'jixiao',
        name: 'jixiao',
      	meta: {
      		title: '绩效',
          keepAlive: true
      	},
      	component: jixiao
      },{
      	path: 'linshiyonggong',
        name: 'linshiyonggong',
      	meta: {
      		title: '临时用工工资',
          keepAlive: true
      	},
      	component: linshiyonggong
      },{
      	path: 'heduibiao',
        name: 'heduibiao',
      	meta: {
      		title: '核对表',
          keepAlive: true
      	},
      	component: heduibiao
      }]
    },
    {
      path: '/yuegongzi',
      redirect: '/yuegongzi/yuefengren',
      component: yuegongziIndex,
      children: [{
      	path: 'yuefengren',
        name: 'yuefengren',
      	meta: {
      		title: '缝纫汇总',
          keepAlive: true
      	},
      	component: yuefengren
      },{
      	path: 'yuebaozhuang',
        name: 'yuebaozhuang',
      	meta: {
      		title: '包装汇总',
          keepAlive: true
      	},
      	component: yuebaozhuang
      },{
      	path: 'yuechengxing',
        name: 'yuechengxing',
      	meta: {
      		title: '成型汇总',
          keepAlive: true
      	},
      	component: yuechengxing
      },{
      	path: 'yuezuzhuang',
        name: 'yuezuzhuang',
      	meta: {
      		title: '组装汇总',
          keepAlive: true
      	},
      	component: yuezuzhuang
      },{
      	path: 'yuehanjie',
        name: 'yuehanjie',
      	meta: {
      		title: '焊接汇总',
          keepAlive: true
      	},
      	component: yuehanjie
      },{
      	path: 'yuetuzhuangddt',
        name: 'yuetuzhuangddt',
      	meta: {
      		title: '打堵头汇总',
          keepAlive: true
      	},
      	component: yuetuzhuangddt
      },{
      	path: 'yuetuzhuang',
        name: 'yuetuzhuang',
      	meta: {
      		title: '涂装汇总',
          keepAlive: true
      	},
      	component: yuetuzhuang
      }]
    },
    {
      path: '/yueribao',
      redirect: '/yueribao/yuerbfengren',
      component: yueribaoIndex,
      children: [{
      	path: 'yuerbfengren',
        name: 'yuerbfengren',
      	meta: {
      		title: '缝纫日报月度汇总',
          keepAlive: true
      	},
      	component: yuerbfengren
      },{
      	path: 'yuerbbaozhuang',
        name: 'yuerbbaozhuang',
      	meta: {
      		title: '包装日报月度汇总',
          keepAlive: true
      	},
      	component: yuerbbaozhuang
      },{
      	path: 'yuerbchengxing',
        name: 'yuerbchengxing',
      	meta: {
      		title: '成型日报月度汇总',
          keepAlive: true
      	},
      	component: yuerbchengxing
      },{
      	path: 'yuerbzuzhuang',
        name: 'yuerbzuzhuang',
      	meta: {
      		title: '组装日报月度汇总',
          keepAlive: true
      	},
      	component: yuerbzuzhuang
      },{
      	path: 'yuerbhanjie',
        name: 'yuerbhanjie',
      	meta: {
      		title: '焊接日报月度汇总',
          keepAlive: true
      	},
      	component: yuerbhanjie
      },{
      	path: 'yuerbliangting',
        name: 'yuerbliangting',
      	meta: {
      		title: '涂装凉亭日报月度汇总',
          keepAlive: true
      	},
      	component: yuerbliangting
      },{
      	path: 'yuerblinxi',
        name: 'yuerblinxi',
      	meta: {
      		title: '涂装淋洗日报月度汇总',
          keepAlive: true
      	},
      	component: yuerblinxi
      }]
    },
    {
      path: '/zidingyiribao',
      redirect: '/zidingyiribao/zdyrbfengren',
      component: zidingyiribaoIndex,
      children: [{
      	path: 'zdyrbfengren',
        name: 'zdyrbfengren',
      	meta: {
      		title: '缝纫日报自定义汇总',
          keepAlive: true
      	},
      	component: zdyrbfengren
      },{
      	path: 'zdyrbbaozhuang',
        name: 'zdyrbbaozhuang',
      	meta: {
      		title: '包装日报自定义汇总',
          keepAlive: true
      	},
      	component: zdyrbbaozhuang
      },{
      	path: 'zdyrbchengxing',
        name: 'zdyrbchengxing',
      	meta: {
      		title: '成型日报自定义汇总',
          keepAlive: true
      	},
      	component: zdyrbchengxing
      },{
      	path: 'zdyrbzuzhuang',
        name: 'zdyrbzuzhuang',
      	meta: {
      		title: '组装日报自定义汇总',
          keepAlive: true
      	},
      	component: zdyrbzuzhuang
      },{
      	path: 'zdyrbhanjie',
        name: 'zdyrbhanjie',
      	meta: {
      		title: '焊接日报自定义汇总',
          keepAlive: true
      	},
      	component: zdyrbhanjie
      },{
      	path: 'zdyrblinxi',
        name: 'zdyrblinxi',
      	meta: {
      		title: '涂装淋洗日报自定义汇总',
          keepAlive: true
      	},
      	component: zdyrblinxi
      },{
      	path: 'zdyrbliangting',
        name: 'zdyrbliangting',
      	meta: {
      		title: '涂装凉亭日报自定义汇总',
          keepAlive: true
      	},
      	component: zdyrbliangting
      }]
    }
  ],
})

export default vueRouter
